import NaptimeResource from './NaptimeResource';

export default class AuthoringUserCoursePermissions extends NaptimeResource {
  static RESOURCE_NAME = 'authoringUserCoursePermissions.v1';

  static my(courseId) {
    return this.finder('my', {
      params: { courseId },
    });
  }
}
